export default [ {
        value: '1',
        label: 'POS'
    },
    {
        value: '2',
        label: '支付宝-花呗分期'
    },
    {
        value: '3',
        label: '微信'
    },
    {
        value: '5',
        label: '京东-银联二维码'
    },
    {
        value: '6',
        label: '微信商家扫码'
    },
    {
        value: '7',
        label: '支付宝商家扫码'
    },
];




// WEBPACK FOOTER //
// ./src/service/constant/TransactionType.js